import { createRoot, hydrateRoot } from "react-dom/client";
import { initAdConsent } from "@suite/ui";
import { Root } from "./Root.tsx";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root missing from index.html");

// Production index.html carries the prerendered page (see src/prerender.tsx),
// so hydrate it; the dev server serves an empty #root and renders from scratch.
if (container.hasChildNodes()) {
  hydrateRoot(container, <Root />);
} else {
  createRoot(container).render(<Root />);
}

// After the root, never before: the consent manager can grant consent, and a
// grant that lands mid-hydration would mismatch the prerendered markup.
initAdConsent();
